/**
 * Sidebar Thumbnails Product Gallery
 * Handles thumbnail clicks and main image switching for sidebar layout
 */

(function () {
  "use strict";

  const SidebarThumbnails = {
    selectors: {
      container: "[data-sidebar-thumbnails-area]",
      thumbnailWrapper: "[data-thumbnails-wrapper]",
      thumbnailSidebar: "[data-thumbnails-sidebar]",
      thumbnailItem: ".thumbnail-item",
      mainImageArea: "[data-main-image-area]",
      currentMainMedia: "[data-current-main-media]",
      mediaTemplates: "[data-media-templates]",
      chevronButtonDown: "[data-scroll-down]",
      chevronButtonUp: "[data-scroll-up]",
    },

    classes: {
      active: "active",
    },

    init: function () {
      const container = document.querySelector(this.selectors.container);
      if (!container) return;
      this.root = container.closest("[data-product]") || document;

      this.setupThumbnailClicks();
      this.setupKeyboardNavigation();
      this.setupVariantChange();
      this.setupChevronScroll();
      this.syncHeights();

      // İlk thumbnail'i aktif yap
      this.setActiveThumbnail(0);

      // Oryantasyon değişiminde slayt index'ini koru ve video overlay yönet
      this.mobileBreakpoint = 768;
      this.wasMobile = window.innerWidth <= this.mobileBreakpoint;
      this._overlayVideoData = null;
      this._lastMediaId = this.getDesktopCurrentMediaId() || this.getMobileCurrentMediaId();
      this._lastDesktopIndex = 0;
      this._videoPlayingBeforeResize = null;

      let resizeTimeout;
      window.addEventListener("resize", () => {
        // Debounce öncesi ANINDA video durumunu yakala
        // Sadece ilk resize'da yakala (sonraki resize'larda IntersectionObserver videoyu duraklattıysa ezilmesin)
        var goingToLandscape = window.innerWidth > this.mobileBreakpoint && this.wasMobile;
        if (goingToLandscape && !this._videoPlayingBeforeResize) {
          var found = this.findPlayingVideoImmediate();
          if (found) {
            this._videoPlayingBeforeResize = found;
            this._videoTimeBeforeResize = found.tagName === 'VIDEO' ? found.currentTime : 0;
          }
        }

        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.syncHeights();
          this.handleOrientationChange();
        }, 200);
      });

      // Image load olduğunda height'ı yeniden hesapla
      const mainImageArea = document.querySelector(
        this.selectors.mainImageArea
      );
      if (mainImageArea) {
        const images = mainImageArea.querySelectorAll("img");
        images.forEach((img) => {
          if (img.complete) {
            this.syncHeights();
          } else {
            img.addEventListener("load", () => this.syncHeights());
          }
        });
      }
    },

    setupThumbnailClicks: function () {
      const thumbnails = document.querySelectorAll(
        this.selectors.thumbnailItem
      );

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", (e) => {
          e.preventDefault();
          this.switchToImage(index);
        });

        // Accessibility: Enter ve Space tuşlarıyla da çalışsın
        thumbnail.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.switchToImage(index);
          }
        });

        // Thumbnail'lere tabindex ekle
        thumbnail.setAttribute("tabindex", "0");
        thumbnail.setAttribute("role", "button");
        thumbnail.setAttribute("aria-label", `View image ${index + 1}`);
      });
    },

    setupKeyboardNavigation: function () {
      const thumbnailSidebar = document.querySelector(
        this.selectors.thumbnailSidebar
      );
      if (!thumbnailSidebar) return;

      document.addEventListener("keydown", (e) => {
        if (!document.querySelector(this.selectors.container)) return;

        const currentIndex = this.getCurrentActiveIndex();
        const totalThumbnails = document.querySelectorAll(
          this.selectors.thumbnailItem
        ).length;

        // Arrow Up/Down navigation
        if (e.key === "ArrowDown") {
          e.preventDefault();
          const nextIndex = (currentIndex + 1) % totalThumbnails;
          this.switchToImage(nextIndex);
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          const prevIndex =
            (currentIndex - 1 + totalThumbnails) % totalThumbnails;
          this.switchToImage(prevIndex);
        }
      });
    },

    setupVariantChange: function () {
      // Shopify varyant değişimi event'ini dinle
      document.addEventListener("variant:change", (e) => {
        if (e.detail && e.detail.variant && e.detail.variant.featured_media) {
          const mediaId = e.detail.variant.featured_media.id;
          this.switchToMediaId(mediaId);
        }
      });
    },

    syncHeights: function () {
      const mainImageArea = document.querySelector(
        this.selectors.mainImageArea
      );
      const thumbnailWrapper = document.querySelector(
        this.selectors.thumbnailWrapper
      );
      const chevronButton = document.querySelector(
        this.selectors.chevronButton
      );
      const thumbnailSidebar = document.querySelector(
        this.selectors.thumbnailSidebar
      );

      if (!mainImageArea || !thumbnailWrapper || !thumbnailSidebar) return;

      // Thumbnail sidebar için sabit max-height kullan (4 thumbnail için)
      // 150px × 4 + 10px gap × 3 = 630px
      const fixedMaxHeight = 630;

      // Sabit yükseklikleri ayarla - CSS ile aynı değerler
      thumbnailWrapper.style.height = `${fixedMaxHeight}px`;
      thumbnailSidebar.style.maxHeight = `${fixedMaxHeight}px`;
      mainImageArea.style.height = `${fixedMaxHeight}px`;
    },

    setupChevronScroll: function () {
      const chevronButtonDown = document.querySelector(
        this.selectors.chevronButtonDown
      );
      const chevronButtonUp = document.querySelector(
        this.selectors.chevronButtonUp
      );
      const thumbnailSidebar = document.querySelector(
        this.selectors.thumbnailSidebar
      );

      if (!thumbnailSidebar) return;

      const scrollAmount = 160; // 150px thumbnail + 10px gap

      // Disable mouse wheel scrolling - only buttons work
      thumbnailSidebar.addEventListener(
        "wheel",
        (e) => {
          e.preventDefault();
        },
        { passive: false }
      );

      // Disable touch scrolling on mobile
      thumbnailSidebar.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
        },
        { passive: false }
      );

      // DOWN button - Aşağı scroll
      if (chevronButtonDown) {
        chevronButtonDown.addEventListener("click", () => {
          thumbnailSidebar.scrollBy({
            top: scrollAmount,
            behavior: "smooth",
          });
        });
      }

      // UP button - Yukarı scroll
      if (chevronButtonUp) {
        chevronButtonUp.addEventListener("click", () => {
          thumbnailSidebar.scrollBy({
            top: -scrollAmount,
            behavior: "smooth",
          });
        });
      }

      // Scroll event ile button durumlarını güncelle
      if (chevronButtonDown && chevronButtonUp) {
        thumbnailSidebar.addEventListener("scroll", () => {
          this.updateChevronStates();
        });

        // İlk durumu ayarla
        this.updateChevronStates();
      }
    },

    updateChevronStates: function () {
      const chevronButtonDown = document.querySelector(
        this.selectors.chevronButtonDown
      );
      const chevronButtonUp = document.querySelector(
        this.selectors.chevronButtonUp
      );
      const thumbnailSidebar = document.querySelector(
        this.selectors.thumbnailSidebar
      );

      if (!chevronButtonDown || !chevronButtonUp || !thumbnailSidebar) return;

      const scrollTop = thumbnailSidebar.scrollTop;
      const scrollHeight = thumbnailSidebar.scrollHeight;
      const clientHeight = thumbnailSidebar.clientHeight;
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollHeight - scrollTop <= clientHeight + 10;

      // UP button - Üstteyse gizle
      if (isAtTop) {
        chevronButtonUp.style.display = "none";
      } else {
        chevronButtonUp.style.display = "flex";
      }

      // DOWN button - Alttaysa disable et
      if (isAtBottom) {
        chevronButtonDown.disabled = true;
      } else {
        chevronButtonDown.disabled = false;
      }
    },

    switchToImage: function (index) {
      this._lastDesktopIndex = index;
      const thumbnails = this.root.querySelectorAll(this.selectors.thumbnailItem);
      const currentThumb = thumbnails[index];
      if (currentThumb && currentThumb.hasAttribute("data-media-id")) {
        this._lastMediaId = currentThumb.getAttribute("data-media-id");
      }
      this.setActiveThumbnail(index);
      this.updateMainImage(index);
      this.scrollThumbnailIntoView(index);
    },

    switchToMediaId: function (mediaId) {
      const thumbnail = document.querySelector(`[data-media-id="${mediaId}"]`);
      if (thumbnail) {
        const index = parseInt(thumbnail.getAttribute("data-thumbnail-index"));
        this.switchToImage(index);
      }
    },

    setActiveThumbnail: function (index) {
      const thumbnails = document.querySelectorAll(
        this.selectors.thumbnailItem
      );

      thumbnails.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add(this.classes.active);
          thumb.setAttribute("aria-current", "true");
        } else {
          thumb.classList.remove(this.classes.active);
          thumb.removeAttribute("aria-current");
        }
      });
    },

    pauseAllActiveMedia: function() {
      var root = this.root || document;

      // HTML5 video duraklat
      var videos = root.querySelectorAll('video');
      videos.forEach(function(video) {
        if (!video.paused) {
          video.pause();
        }
      });

      // iframe video duraklat (YouTube/Vimeo)
      var iframes = root.querySelectorAll('iframe');
      iframes.forEach(function(iframe) {
        try {
          // YouTube
          iframe.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'pauseVideo'}), '*');
          // Vimeo
          iframe.contentWindow.postMessage(JSON.stringify({method: 'pause'}), '*');
        } catch(e) {}
      });

      // Tema'nın media:hidden event'ini dispatch et
      var mediaWrappers = root.querySelectorAll('[data-product-single-media-wrapper]');
      mediaWrappers.forEach(function(wrapper) {
        wrapper.dispatchEvent(new CustomEvent('theme:media:hidden', {bubbles: true}));
      });
    },

    updateMainImage: function (index) {
      // Önce mevcut oynayan medyayı durdur
      this.pauseAllActiveMedia();

      const currentMainMedia = document.querySelector(
        this.selectors.currentMainMedia
      );
      const mediaTemplatesElement = document.querySelector(
        this.selectors.mediaTemplates
      );

      if (!currentMainMedia || !mediaTemplatesElement) {
        console.warn(
          "Sidebar Thumbnails: Main media area or templates not found"
        );
        return;
      }

      // <template> tag'inin content'ine eriş
      const mediaTemplates =
        mediaTemplatesElement.content || mediaTemplatesElement;

      // Template içinden ilgili media'yı bul
      const mediaTemplate = mediaTemplates.querySelector(
        `[data-media-index="${index}"]`
      );

      if (!mediaTemplate) {
        console.warn(
          `Sidebar Thumbnails: Template with index ${index} not found`
        );
        return;
      }

      // Badge elementlerini koru (absolute positioned elementler)
      const badges = Array.from(currentMainMedia.children).filter(
        (child) =>
          child.classList.contains("absolute") ||
          child.classList.contains("badge_image") ||
          child.classList.contains("kampanya_gorsel_ustu_badge")
      );

      // Mevcut media wrapper'ı bul (data-product-single-media-wrapper veya id başlangıcı FeaturedMedia)
      const currentMediaWrapper = Array.from(currentMainMedia.children).find(
        (child) =>
          child.hasAttribute("data-product-single-media-wrapper") ||
          child.hasAttribute("data-type") ||
          (child.id && child.id.startsWith("FeaturedMedia"))
      );

      // Yeni media içeriğini template'den al
      const newMediaHTML = mediaTemplate.innerHTML.trim();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = newMediaHTML;
      const newMediaWrapper = tempDiv.firstElementChild;

      if (!newMediaWrapper) {
        console.warn("No media wrapper found in template");
        return;
      }

      if (currentMediaWrapper) {
        // Mevcut media wrapper'ı yenisiyle değiştir
        currentMediaWrapper.replaceWith(newMediaWrapper);
      } else {
        // İlk yükleme - badge'lerden sonra ekle
        const lastBadge = badges.length > 0 ? badges[badges.length - 1] : null;
        if (lastBadge) {
          lastBadge.after(newMediaWrapper);
        } else {
          currentMainMedia.appendChild(newMediaWrapper);
        }
      }

      // Badge'lerin doğru sırada olduğundan emin ol
      badges.forEach((badge) => {
        currentMainMedia.insertBefore(badge, currentMainMedia.firstChild);
      });

      // Video/model varsa event dispatch et ve click handler ekle
      const newMedia = currentMainMedia.querySelector("[data-type]");
      if (newMedia) {
        const mediaType = newMedia.getAttribute("data-type");
        if (
          mediaType === "video" ||
          mediaType === "external_video" ||
          mediaType === "model"
        ) {
          newMedia.dispatchEvent(new CustomEvent("mediaVisible"));

          // Video için deferred-media butonuna click handler ekle
          this.bindDeferredMediaButton(newMedia);
        }
      }

      // Lazy loading için trigger
      const newImages = currentMainMedia.querySelectorAll("img");
      newImages.forEach((img) => {
        if (img.loading === "lazy") {
          img.loading = "eager";
        }

        // Height'ı yeniden hesapla
        if (img.complete) {
          this.syncHeights();
        } else {
          img.addEventListener("load", () => this.syncHeights(), {
            once: true,
          });
        }
      });

      // Yeni görsele PhotoSwipe event binding ekle
      this.bindPhotoSwipeToNewImage();
    },

    scrollThumbnailIntoView: function (index) {
      const thumbnail = document.querySelectorAll(this.selectors.thumbnailItem)[
        index
      ];
      const sidebar = document.querySelector(this.selectors.thumbnailSidebar);

      if (thumbnail && sidebar) {
        const thumbnailTop = thumbnail.offsetTop;
        const thumbnailHeight = thumbnail.offsetHeight;
        const sidebarScrollTop = sidebar.scrollTop;
        const sidebarHeight = sidebar.clientHeight;

        // Thumbnail görünür değilse scroll et
        if (thumbnailTop < sidebarScrollTop) {
          sidebar.scrollTo({
            top: thumbnailTop - 8,
            behavior: "smooth",
          });
        } else if (
          thumbnailTop + thumbnailHeight >
          sidebarScrollTop + sidebarHeight
        ) {
          sidebar.scrollTo({
            top: thumbnailTop + thumbnailHeight - sidebarHeight + 8,
            behavior: "smooth",
          });
        }
      }
    },

    getCurrentActiveIndex: function () {
      const activeThumbnail = this.root.querySelector(
        this.selectors.thumbnailItem + "." + this.classes.active
      );
      return activeThumbnail
        ? parseInt(activeThumbnail.getAttribute("data-thumbnail-index"))
        : 0;
    },

    getMobileCurrentMediaId: function() {
      var slider = this.getMobileSliderElement();
      if (!slider) return null;

      var flkty = typeof themeVendor !== "undefined" && themeVendor.Flickity && themeVendor.Flickity.data(slider);
      if (flkty && flkty.selectedElement) {
        var selectedId = flkty.selectedElement.getAttribute("data-id");
        if (selectedId) return selectedId;
        var selectedMediaId = flkty.selectedElement.getAttribute("data-media-id");
        if (selectedMediaId && selectedMediaId.indexOf("-") > -1) {
          return selectedMediaId.split("-").pop();
        }
      }

      var selectedCell = slider.querySelector(".is-selected[data-id]");
      if (selectedCell) return selectedCell.getAttribute("data-id");
      var selectedCellMedia = slider.querySelector(".is-selected[data-media-id]");
      if (selectedCellMedia) {
        var sid = selectedCellMedia.getAttribute("data-media-id");
        if (sid && sid.indexOf("-") > -1) return sid.split("-").pop();
      }

      var visibleCell =
        slider.querySelector(".carousel-cell-mobile:not(.media--hidden)[data-id]") ||
        slider.querySelector(".product-single__media-slide:not(.media--hidden)[data-id]");
      if (visibleCell) return visibleCell.getAttribute("data-id");
      var visibleCellMedia =
        slider.querySelector(".carousel-cell-mobile:not(.media--hidden)[data-media-id]") ||
        slider.querySelector(".product-single__media-slide:not(.media--hidden)[data-media-id]");
      if (visibleCellMedia) {
        var vid = visibleCellMedia.getAttribute("data-media-id");
        if (vid && vid.indexOf("-") > -1) return vid.split("-").pop();
      }
      return null;
    },

    getDesktopCurrentMediaId: function() {
      var currentMainMedia = this.root.querySelector(this.selectors.currentMainMedia);
      if (currentMainMedia) {
        var activeMedia = currentMainMedia.querySelector(
          "[data-product-single-media-wrapper][data-id]"
        );
        if (activeMedia) return activeMedia.getAttribute("data-id");
      }

      // Fallback: active thumbnail
      var activeThumb = this.root.querySelector(
        this.selectors.thumbnailItem + "." + this.classes.active + "[data-media-id]"
      );
      if (activeThumb) return activeThumb.getAttribute("data-media-id");

      return null;
    },

    getMobileSliderElement: function() {
      var sliders = Array.from(
        this.root.querySelectorAll("[data-product-single-media-slider]")
      );
      if (!sliders.length) return null;

      // Mobil slider'ı bul: "hidden m:block" class'lı parent'ın içindeki slider
      // classList.contains ile kontrol et (CSS escape sorunlarından kaçın)
      var hasMobileClass = function(element) {
        var el = element;
        while (el && el !== document.body) {
          if (el.classList && el.classList.contains("m:block")) return true;
          el = el.parentElement;
        }
        return false;
      };

      var mobileContainerSlider = sliders.find(function(slider) {
        return hasMobileClass(slider);
      });

      if (mobileContainerSlider) return mobileContainerSlider;

      // Fallback: visible (display != none) slider
      var visibleSlider = sliders.find(function(slider) {
        var container = slider.parentElement || slider;
        var style = window.getComputedStyle(container);
        return style.display !== "none" && style.visibility !== "hidden";
      });

      if (visibleSlider) return visibleSlider;
      return sliders[0];
    },

    applyDesktopMediaById: function(mediaId) {
      if (!mediaId) return;
      var thumbnail = this.root.querySelector(
        this.selectors.thumbnailItem + '[data-media-id="' + mediaId + '"]'
      );
      if (!thumbnail) return;
      var index = parseInt(thumbnail.getAttribute("data-thumbnail-index"), 10);
      if (!Number.isNaN(index)) {
        this.switchToImage(index);
      }
    },

    handleOrientationChange: function() {
      var isMobile = window.innerWidth <= this.mobileBreakpoint;

      // Layout değişmediyse bir şey yapma
      if (isMobile === this.wasMobile) return;

      var overlay = document.getElementById('video-fullscreen-overlay');
      var self = this;

      // Scroll pozisyonunu koru: ürün alanının viewport'taki konumunu kaydet
      var productRoot = this.root;
      var scrollAnchor = productRoot && productRoot.getBoundingClientRect
        ? productRoot.getBoundingClientRect().top + window.pageYOffset
        : null;

      if (!isMobile && this.wasMobile) {
        var mobileMediaId = self.getMobileCurrentMediaId() || self._lastMediaId;

        // ÖNCE video overlay'ini göster (pauseAllActiveMedia çalışmadan önce)
        if (!overlay) {
          var playingVideo = self._videoPlayingBeforeResize || this.findPlayingVideo();
          var savedTime = self._videoTimeBeforeResize || 0;
          self._videoPlayingBeforeResize = null;
          self._videoTimeBeforeResize = 0;
          if (playingVideo) {
            this.showVideoOverlay(playingVideo, savedTime);
          }
        } else {
          self._videoPlayingBeforeResize = null;
          self._videoTimeBeforeResize = 0;
        }

        // SONRA desktop medya seçimini yap
        if (mobileMediaId) {
          self._lastMediaId = mobileMediaId;
          self.enforceDesktopMediaSelection(mobileMediaId);
        }
      } else if (isMobile && !this.wasMobile) {
        if (overlay) {
          this.returnVideoToOriginal(true);
        }
        var desktopMediaId = self.getDesktopCurrentMediaId();
        if (!desktopMediaId) {
          desktopMediaId = self._lastMediaId;
        }
        if (desktopMediaId) {
          self._lastMediaId = desktopMediaId;
          self.enforceMobileMediaSelection(desktopMediaId);
        }
      }

      this.wasMobile = isMobile;

      // Oryantasyon geçişi sonrası scroll pozisyonunu geri yükle
      if (scrollAnchor !== null) {
        requestAnimationFrame(function() {
          window.scrollTo(0, scrollAnchor);
        });
        // Layout shift gecikmeli olabilir, ikinci düzeltme
        setTimeout(function() {
          if (productRoot && productRoot.getBoundingClientRect) {
            var currentTop = productRoot.getBoundingClientRect().top;
            if (Math.abs(currentTop) > 50) {
              window.scrollTo(0, scrollAnchor);
            }
          }
        }, 400);
      }
    },

    findCellIndexByMediaId: function(flkty, target) {
      if (!flkty || !flkty.cells) return -1;
      for (var i = 0; i < flkty.cells.length; i++) {
        var el = flkty.cells[i] && flkty.cells[i].element;
        if (!el) continue;
        var cellId = el.getAttribute("data-id");
        if (String(cellId) === target) return i;
        var cellMediaId = el.getAttribute("data-media-id");
        if (cellMediaId) {
          var parts = cellMediaId.split("-");
          var suffix = parts[parts.length - 1];
          if (String(suffix) === target) return i;
        }
      }
      return -1;
    },

    enforceMobileMediaSelection: function(mediaId) {
      var self = this;
      var target = String(mediaId);
      var startedAt = Date.now();
      var maxWait = 4000;
      var attemptCount = 0;

      if (self._mobileEnforceTimer) {
        clearTimeout(self._mobileEnforceTimer);
        self._mobileEnforceTimer = null;
      }

      var attempt = function() {
        attemptCount++;
        var slider = self.getMobileSliderElement();

        if (!slider) {
          if (Date.now() - startedAt < maxWait) {
            self._mobileEnforceTimer = setTimeout(attempt, 200);
          }
          return;
        }

        var flkty = typeof themeVendor !== "undefined" && themeVendor.Flickity && themeVendor.Flickity.data(slider);

        if (!flkty || !flkty.cells || flkty.cells.length === 0) {
          if (Date.now() - startedAt < maxWait) {
            self._mobileEnforceTimer = setTimeout(attempt, 200);
          }
          return;
        }

        var idx = self.findCellIndexByMediaId(flkty, target);

        if (idx === -1) return;

        if (flkty.selectedIndex === idx) {
          self._lastMediaId = target;
          return;
        }

        // Container gizli→görünür geçişi sonrası Flickity pozisyonlarını güncelle
        flkty.resize();
        flkty.select(idx, false, true);
        self._lastMediaId = target;

        setTimeout(function() {
          var flkty2 = typeof themeVendor !== "undefined" && themeVendor.Flickity && themeVendor.Flickity.data(slider);
          if (!flkty2) return;
          if (flkty2.selectedIndex !== idx) {
            flkty2.resize();
            flkty2.select(idx, false, true);
          }
        }, 500);

        setTimeout(function() {
          var flkty3 = typeof themeVendor !== "undefined" && themeVendor.Flickity && themeVendor.Flickity.data(slider);
          if (!flkty3) return;
          if (flkty3.selectedIndex !== idx) {
            flkty3.resize();
            flkty3.select(idx, false, true);
          }
        }, 1200);
      };

      // Tema'nın Flickity init'ini bekle (tema 50ms debounce, biz 200ms sonra)
      self._mobileEnforceTimer = setTimeout(attempt, 300);
    },

    enforceDesktopMediaSelection: function(mediaId) {
      var self = this;
      var target = String(mediaId);
      var startedAt = Date.now();

      var tick = function() {
        self.applyDesktopMediaById(target);
        var current = self.getDesktopCurrentMediaId();
        if (String(current) === target) return;
        if (Date.now() - startedAt < 1500) {
          setTimeout(tick, 120);
        }
      };

      tick();
    },

    findPlayingVideo: function() {
      // Sadece mobil galerideki AKTİF (görünen) slayttaki oynayan videoyu bul.
      // Resim slaytındayken yan çevrildiğinde overlay açılmaz.
      var mobileSlider = this.getMobileSliderElement();
      if (!mobileSlider) return null;
      
      var activeSlide = mobileSlider.querySelector('.carousel-cell-mobile:not(.media--hidden)') ||
        mobileSlider.querySelector('.product-single__media-slide:not(.media--hidden)');
      if (!activeSlide) return null;
      
      var video = activeSlide.querySelector('video');
      if (video && !video.paused && !video.ended) {
        return video;
      }
      // iframe video (YouTube/Vimeo) kontrolü
      var iframe = activeSlide.querySelector('iframe');
      if (iframe) {
        var deferredMedia = activeSlide.querySelector('[data-deferred-media]');
        if (deferredMedia && deferredMedia.getAttribute('loaded') === 'true') {
          return iframe;
        }
      }
      return null;
    },

    findPlayingVideoImmediate: function() {
      // resize anında ANINDA çağrılır (debounce öncesi).
      // IntersectionObserver henüz tetiklenmediği için video hâlâ oynuyor olabilir.
      // Tüm ürün alanındaki oynayan videoları tara.
      var root = this.root || document;

      // HTML5 video
      var videos = root.querySelectorAll('video');
      for (var i = 0; i < videos.length; i++) {
        if (!videos[i].paused && !videos[i].ended) {
          return videos[i];
        }
      }

      // iframe video (YouTube/Vimeo) - aktif slayttaki yüklü iframe
      var mobileSlider = this.getMobileSliderElement();
      if (mobileSlider) {
        var activeSlide = mobileSlider.querySelector('.carousel-cell-mobile:not(.media--hidden)') ||
          mobileSlider.querySelector('.product-single__media-slide:not(.media--hidden)');
        if (activeSlide) {
          var iframe = activeSlide.querySelector('iframe');
          var deferredMedia = activeSlide.querySelector('[data-deferred-media]');
          if (iframe && deferredMedia && deferredMedia.getAttribute('loaded') === 'true') {
            return iframe;
          }
        }
      }

      return null;
    },

    showVideoOverlay: function(mediaElement, savedTime) {
      if (document.getElementById('video-fullscreen-overlay')) return;
      
      var self = this;
      var isVideo = mediaElement.tagName === 'VIDEO';
      var isIframe = mediaElement.tagName === 'IFRAME';
      
      // Medyanın orijinal konumunu kaydet
      this._overlayVideoData = {
        element: mediaElement,
        parent: mediaElement.parentElement,
        nextSibling: mediaElement.nextSibling,
        originalStyles: mediaElement.getAttribute('style') || '',
        currentTime: isVideo ? (savedTime || mediaElement.currentTime) : 0,
        wasMuted: isVideo ? mediaElement.muted : false,
        isIframe: isIframe
      };
      
      // Overlay oluştur
      var overlay = document.createElement('div');
      overlay.id = 'video-fullscreen-overlay';
      overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:99999;background:#000;display:flex;align-items:center;justify-content:center;';
      
      // Kapatma butonu
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Videoyu kapat');
      closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
      closeBtn.style.cssText = 'position:absolute;top:15px;right:15px;z-index:100000;color:white;background:rgba(0,0,0,0.6);border:none;width:44px;height:44px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;';
      closeBtn.addEventListener('click', function() {
        self.returnVideoToOriginal(false);
      });
      
      // Medya stilini tam ekran için ayarla
      if (isVideo) {
        mediaElement.style.cssText = 'width:100%;height:100%;max-width:100vw;max-height:100vh;object-fit:contain;';
      } else if (isIframe) {
        mediaElement.style.cssText = 'width:100%;height:100%;max-width:100vw;max-height:100vh;border:none;';
      }
      
      // Medyayı overlay'e taşı
      overlay.appendChild(closeBtn);
      overlay.appendChild(mediaElement);
      document.body.appendChild(overlay);
      
      // Scroll'u kilitle
      document.body.style.overflow = 'hidden';
      
      // Overlay'e taşındıktan sonra oynatmaya devam et
      if (isVideo) {
        // Doğru zamana seek et (IntersectionObserver duraklattıysa kayıp olabilir)
        if (savedTime && mediaElement.currentTime < savedTime) {
          mediaElement.currentTime = savedTime;
        }

        // Hemen oynat
        var playAttempt = function() {
          mediaElement.play().catch(function() {
            mediaElement.muted = true;
            mediaElement.play();
          });
        };

        // Hemen dene, 100ms sonra tekrar dene (DOM taşıma sonrası stabilize olması için)
        playAttempt();
        setTimeout(playAttempt, 150);

        this._onVideoEnded = function() {
          self.returnVideoToOriginal(false);
        };
        mediaElement.addEventListener('ended', this._onVideoEnded);
      } else if (isIframe) {
        try {
          // YouTube oynat
          mediaElement.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'playVideo'}), '*');
          // Vimeo oynat
          mediaElement.contentWindow.postMessage(JSON.stringify({method: 'play'}), '*');
        } catch(e) {}
      }
    },

    returnVideoToOriginal: function(keepPlaying) {
      var overlay = document.getElementById('video-fullscreen-overlay');
      if (!overlay) return;
      
      // Overlay'deki medya elementini bul (video veya iframe)
      var mediaElement = overlay.querySelector('video') || overlay.querySelector('iframe');
      
      if (mediaElement) {
        var isVideo = mediaElement.tagName === 'VIDEO';
        var isIframe = mediaElement.tagName === 'IFRAME';

        // ended event listener'ı kaldır
        if (isVideo && this._onVideoEnded) {
          mediaElement.removeEventListener('ended', this._onVideoEnded);
          this._onVideoEnded = null;
        }
        
        if (!keepPlaying) {
          if (isVideo) {
            mediaElement.pause();
          } else if (isIframe) {
            // YouTube/Vimeo duraklat
            try {
              mediaElement.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'pauseVideo'}), '*');
              mediaElement.contentWindow.postMessage(JSON.stringify({method: 'pause'}), '*');
            } catch(e) {}
          }
        }
        
        // Orijinal stilini geri yükle
        if (this._overlayVideoData) {
          mediaElement.setAttribute('style', this._overlayVideoData.originalStyles);
          
          // Medyayı orijinal yerine geri koy
          var parent = this._overlayVideoData.parent;
          var nextSibling = this._overlayVideoData.nextSibling;
          
          if (parent) {
            if (nextSibling && nextSibling.parentElement === parent) {
              parent.insertBefore(mediaElement, nextSibling);
            } else {
              parent.appendChild(mediaElement);
            }
          }
        }
      }
      
      // Overlay'i kaldır
      overlay.remove();
      document.body.style.overflow = '';
      this._overlayVideoData = null;
    },

    bindDeferredMediaButton: function (mediaContainer) {
      const deferredMedia = mediaContainer.querySelector(
        "[data-deferred-media]"
      );
      const deferredMediaButton = mediaContainer.querySelector(
        "[data-deferred-media-button]"
      );
      const template = mediaContainer.querySelector("template");

      if (!deferredMedia || !deferredMediaButton || !template) return;

      // Eğer zaten yüklenmişse çık
      if (deferredMedia.getAttribute("loaded") === "true") return;

      deferredMediaButton.addEventListener("click", (e) => {
        e.preventDefault();

        // Zaten yüklenmişse tekrar yükleme
        if (deferredMedia.getAttribute("loaded") === "true") return;

        // Template içeriğini al
        const templateContent = template.content.firstElementChild;
        if (!templateContent) return;

        // Video/iframe elementini kopyala ve DOM'a ekle
        const mediaElement = templateContent.cloneNode(true);
        deferredMedia.appendChild(mediaElement);
        deferredMedia.setAttribute("loaded", "true");

        // Poster butonunu gizle
        deferredMediaButton.style.display = "none";

        // Video ise otomatik oynat
        if (mediaElement.tagName === "VIDEO") {
          mediaElement.play().catch(function (error) {
          });
        }

        // iframe ise (YouTube/Vimeo) src'ye autoplay ekle
        if (mediaElement.tagName === "IFRAME") {
          const src = mediaElement.src;
          if (src && !src.includes("autoplay=1")) {
            mediaElement.src =
              src + (src.includes("?") ? "&" : "?") + "autoplay=1";
          }
        }

        // Media play event dispatch et
        mediaContainer.dispatchEvent(
          new CustomEvent("theme:media:play", { bubbles: true })
        );
      });
    },

    bindPhotoSwipeToNewImage: function () {
      const mainImageArea = document.querySelector(
        this.selectors.mainImageArea
      );
      if (!mainImageArea) return;

      const newZoomWrapper = mainImageArea.querySelector("[data-zoom-wrapper]");
      if (!newZoomWrapper) return;

      // Yeni zoom wrapper'a PhotoSwipe click event'ini bağla
      newZoomWrapper.addEventListener("click", (e) => {
        e.preventDefault();
        this.openPhotoSwipe();
      });
    },

    openPhotoSwipe: function () {
      // Template içindeki zoom wrapper'ları bul (duplicate'ları önlemek için)
      const mediaTemplatesElement = document.querySelector(
        "[data-media-templates]"
      );
      if (!mediaTemplatesElement) {
        console.warn("Media templates not found");
        return;
      }

      // Template content'ine eriş
      const mediaTemplates =
        mediaTemplatesElement.content || mediaTemplatesElement;
      const allZoomWrappers = mediaTemplates.querySelectorAll(
        "[data-zoom-wrapper]"
      );

      if (!allZoomWrappers.length) {
        console.warn("No zoom wrappers found in templates");
        return;
      }

      // Aktif thumbnail'in index'ini al
      const currentIndex = this.getCurrentActiveIndex();

      // PhotoSwipe items array'ini oluştur
      let items = [];

      allZoomWrappers.forEach((wrapper) => {
        const imgSrc = wrapper.getAttribute("href");
        const imgWidth = parseInt(wrapper.getAttribute("data-image-width"));
        const imgHeight = parseInt(wrapper.getAttribute("data-image-height"));

        items.push({
          src: imgSrc,
          w: imgWidth,
          h: imgHeight,
          msrc: imgSrc,
        });
      });

      // PhotoSwipe options
      const options = {
        barsSize: { top: 60, bottom: 60 },
        history: false,
        focus: false,
        index: currentIndex,
        mainClass:
          items.length === 1
            ? "pswp-zoom-gallery pswp-zoom-gallery--single"
            : "pswp-zoom-gallery",
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ["caption-close"],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
      };

      // PhotoSwipe'ı doğrudan initialize et
      this.initPhotoSwipe(items, options);
    },

    initPhotoSwipe: function (items, options) {
      const pswpElement = document.querySelector(".pswp");
      if (!pswpElement) {
        console.warn("PhotoSwipe container (.pswp) not found");
        return;
      }

      // PhotoSwipe script'i yüklenmemişse önce yükle
      if (
        !window.themePhotoswipe ||
        !window.themePhotoswipe.PhotoSwipe ||
        !window.themePhotoswipe.PhotoSwipeUI
      ) {
        this.loadPhotoSwipeScript()
          .then(() => {
            this.createPhotoSwipeGallery(items, options, pswpElement);
          })
          .catch((e) => {
            console.error("Failed to load PhotoSwipe script:", e);
          });
      } else {
        this.createPhotoSwipeGallery(items, options, pswpElement);
      }
    },

    loadPhotoSwipeScript: function () {
      return new Promise((resolve, reject) => {
        // Eğer zaten yüklenmişse direkt resolve
        if (window.themePhotoswipe) {
          resolve();
          return;
        }

        // PhotoSwipe script URL'ini kontrol et
        if (
          !window.theme ||
          !window.theme.assets ||
          !window.theme.assets.photoswipe
        ) {
          reject(new Error("PhotoSwipe asset URL not found"));
          return;
        }

        // Script'i dinamik olarak yükle
        const script = document.createElement("script");
        script.src = window.theme.assets.photoswipe;
        script.onload = () => {
          // Script yüklendikten sonra kısa bir bekleme
          setTimeout(() => {
            if (window.themePhotoswipe) {
              resolve();
            } else {
              reject(new Error("PhotoSwipe library not initialized"));
            }
          }, 50);
        };
        script.onerror = () =>
          reject(new Error("Failed to load PhotoSwipe script"));
        document.head.appendChild(script);
      });
    },

    createPhotoSwipeGallery: function (items, options, pswpElement) {
      const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
      const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

      // Scroll lock
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: true })
      );

      // PhotoSwipe instance oluştur
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI, items, options);

      // Close button'ı bul ve event listener ekle
      const closeBtn = pswpElement.querySelector(".pswp__custom-close");
      if (closeBtn) {
        const closeHandler = () => {
          gallery.close();
        };

        // Close button click event
        closeBtn.addEventListener("click", closeHandler);

        // Gallery kapandığında cleanup
        gallery.listen("close", () => {
          // Event listener'ı temizle
          closeBtn.removeEventListener("click", closeHandler);

          // Scroll unlock
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: true,
              detail: 400,
            })
          );
        });
      } else {
        // Close button yoksa sadece scroll unlock ekle
        gallery.listen("close", () => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: true,
              detail: 400,
            })
          );
        });
      }

      // Initialize ve aç
      gallery.init();
    },
  };

  // DOM ready olduğunda başlat
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () =>
      SidebarThumbnails.init()
    );
  } else {
    SidebarThumbnails.init();
  }

  // Shopify section reload için
  document.addEventListener("shopify:section:load", () => {
    SidebarThumbnails.init();
  });

  // Global erişim için
  window.SidebarThumbnails = SidebarThumbnails;
})();
 